// @ts-nocheck
import { BoxV2 } from 'sonata-react-components';
import styled from 'styled-components';

export const ColumnOptionsStyle = styled(BoxV2)`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  .columnOptions {
    &__title {
      color: ${props => props.theme.uiColors.reportColumnOptions};
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeS};
    }

    &__clear {
      background: ${props => props.theme.uiColors.tableBackground};
      display: flex;
      justify-content: end;
      padding-top: 16px;
    }

    &__multipleTag {
      display: flex;
      flex-direction: column;
      padding: 0 16px 16px 16px;
      background: ${props => props.theme.uiColors.tableBackground};

      &Title {
        color: ${props => props.theme.uiColors.reportColumnOptions};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeXS};
        margin-bottom: 8px;
      }

      &Selector {
        align-items: center;
      }
    }

    &__settings {
      background: ${props => props.theme.uiColors.tableBackground};
      padding: 16px;
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      &Title {
        color: ${props => props.theme.uiColors.reportColumnOptions};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeS};
        margin-top: 32px;
      }

      &Container {
        display: flex;
        align-items: center;
      }

      &Label {
        padding: 0 8px;
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeXS};

        &Bold {
          font-family: ${props => props.theme.fontBold};
          margin: 0 2px;
        }
      }
    }
  }
`;
